<template>
  <div class="models">
    <page-search
      :searchFormConfig="searchFormConfig"
      :pageTitle="$t('general.router-model-list')"
      @resetBtnClick="handleResetClick"
      @queryBtnClick="handleQueryClick"
    >
    </page-search>
    <page-content
      style="margin-top: 10px"
      ref="pageContentRef"
      v-bind="tableOptionsConfig"
      @newBtnClick="handleNewData"
      @editBtnClick="handleEditData"
      @viewBtnClick="handleViewData"
      @pageInfoChange="pageInfoChangeAction"
    >
    </page-content>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import pageSearch from '@/components/PageSearch/page-search'
import pageContent from '@/components/PageContent/page-content.vue'

import { searchFormConfig } from './config/model.form'
import { contentTableConfig } from './config/model.table'
import { useRouter } from 'vue-router'
// 表格基础配置项
const tableOptions = {
  moduleName: 'terminal', // 所属的模块
  pageName: 'models', // 所属的页面
  contentTableConfig, // 表格列的基础配置
  pageAction: 'terminal/getModelListByPage', // 获取表格的Action
  deleteRecordAction: 'terminal/handleDeleteModelById', // 删除record的Action
  pageCountGetter: 'terminal/pageListCount', // 获取表格记录数据总和getters
  pageListGetter: 'terminal/pageListData' // 获取表格列表数据getters
}

const tableOptionsConfig = computed(() => tableOptions)

const pageContentRef = ref('')
const pageSearchRef = ref('')

const handleQueryClick = (queryInfo) => {
  // 调用page-search中的getPageData方法
  pageContentRef.value.getPageData(queryInfo)
}
const handleResetClick = () => {
  pageContentRef.value.getPageData()
}
const router = useRouter()
const handleViewData = (id) => {
  router.push(`/model/view/${id}`)
}

const handleEditData = (id) => {
  router.push(`/model/edit/${id}`)
}

const handleNewData = (id) => {
  router.push(`/model/new`)
}

const pageInfoChangeAction = () => {
  const formData = pageSearchRef.value.getCurrentFieldValues()
  pageContentRef.value.getPageData(formData)
}
</script>
